import Vue from 'vue'
import store from './store'
import Router from 'vue-router'   
import Login from './views/Login.vue' 
import Index from './views/Index.vue'    


Vue.use(Router)

const router =new Router({
  routes: [
    { path: '/', redirect: '/login' }, 
    {
      path: '/login',
      name: 'login',
      meta:{index:0},
      component: Login
    },
    {
      path: '/index',
      name: 'index',
      meta:{index:0},
      component: Index
    }
     
  ]
}) 
router.beforeEach((to, from, next) => {
  let ua = window.navigator.userAgent.toLowerCase();
  if(ua.match(/MicroMessenger/i) == 'micromessenger'){
    if (to.name!='login'&&!store.state.isLogin) {
      return next({ name:'login',params:{backurl:to.name},query:to.query});
    }  
  }else{ 
    if (to.name!='login'&&!store.state.isLogin) {
      return next({ name:'login',params:{backurl:to.name},query:to.query});
    }  

  } 
  next();
})

export default router